export default "__VITE_ASSET__C3_xESnu__"